import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

export default function NewsCard({ item, index = 0 }: { item: NewsItem; index?: number }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex animate-fade-up flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative h-44 w-full overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 泰剧资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-0.5 text-xs font-medium text-primary-600">
          {item.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{item.summary}</p>
        <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-calendar-line"></i>
          {item.date}
        </div>
      </div>
    </Link>
  );
}